/**
 * useRealtimeNotifications(userId)
 *
 * Subscribes to INSERTs on public.notifications scoped to the given
 * user_id, and invalidates the React Query notification list when one
 * arrives. Mount in the app shell (or any component that always lives
 * while the user is signed in).
 *
 * The hook is a no-op when userId is null/undefined so it can be
 * mounted unconditionally and simply self-disable until the JWT is
 * known.
 */

import { useRealtimeSubscription } from './useRealtimeSubscription'

export function useRealtimeNotifications(userId: string | null | undefined): void {
  useRealtimeSubscription({
    channelName:    `notifications-${userId ?? 'unauth'}`,
    table:          'notifications',
    filter:         userId ? `user_id=eq.${userId}` : undefined,
    events:         ['INSERT'],
    invalidateKeys: [
      ['notifications', userId ?? null],
    ],
    enabled:        !!userId,
  })
}
